<template>
  <div class="footer-m">
    <div class="footer-box">
      <div class="footer-contact">
        <div>联系我们</div>
        <div>邮箱：2900430621@qq.com</div>
        <div>电话：15538285018</div>
      </div>

      <div class="footer-ewm-box">
        <div class="footer-ewm">
          <img src="@/assets/images/ewm-dingyuehao.png" alt="">
          <p>微信订阅号</p>
        </div>
        <div class="footer-ewm" @click="goDownload">
          <img src="@/assets/images/ewm-download.png" alt="">
          <p>APP下载</p>
        </div>
        <div class="footer-ewm">
          <img src="@/assets/images/ewm-kefu.png" alt="">
          <p>微信客服</p>
        </div>
      </div>

      <div class="footer-bottom">
        <p>Copyright © 北京嘉彩科讯科贸有限公司
          <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备B2-2023189</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footer-m',

  methods: {
    goDownload () {
      location.href = this.$store.state.downloadAppUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-m {
  width: 100%;
  background-color: #192333;
  color: #FFFFFF;
  padding: 30px 0 24px;

  .footer-box {
    padding: 0 20px;

    .footer-contact {
      margin-bottom: 25px;
      div {
        font-size: 13px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 24px;

        &:nth-child(1) {
          font-size: 14px;
          line-height: 35px;
        }
      }
    }

    .footer-ewm-box {
      padding-bottom: 25px;
      border-bottom: 1px solid #414C5F;
      @include flex(row);

      .footer-ewm {
        @include flex(col, center, center);
        margin-right: 40px;

        &:nth-child(2) {
          cursor: pointer;
        }

        &:last-child {
          margin-right: none;
        }

        img {
          margin-bottom: 6px;
          width: 66px;
          height: 66px;
          border-radius: 5px;
        }

        p {
          font-size: 12px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          line-height: 14px;
        }
      }
    }

    .footer-bottom {
      margin-top: 14px;

      p, a {
        font-size: 12px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #9BA4B3;
        line-height: 30px;
      }
    }
  }
}
</style>
